import React, { Component } from 'react';



class CategoryHome extends Component {
    render() {
        return (
            <section class="category_div">
                <div class="container">
                    <div class="category_sec">
                        <div class="row category_row">
                            <div class="col-md-6 col-xs-9 pad30 padten">
                                <h3>Browse research areas by Industry</h3>
                            </div>
                            <div class="col-md-6 col-xs-3 pad30 tnt padn">
                                <a href="/industry-reports">View All</a>
                            </div>
                        </div>

                        <div class="row category_row crow1">
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/aerospace-&.png" data-src="../../../img/home_image/advanced.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/advanced-technologies">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Advanced Technologies</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title"></ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/aerospace-&amp;.png" data-src="../../../img/home_image/aerospace-&amp;.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/aerospace-defense">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Aerospace &amp; Defense</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/technologists">
                                                    <i class="fa fa-angle-right"></i>Technology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/weapons-and-ammunition">
                                                    <i class="fa fa-angle-right"></i>Weapons and Ammunition
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/aviation-services">
                                                    <i class="fa fa-angle-right"></i>Aviation Services
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/airport-operations">
                                                    <i class="fa fa-angle-right"></i>Airport Operations
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/mro">
                                                    <i class="fa fa-angle-right"></i>MRO
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/defense-technology">
                                                    <i class="fa fa-angle-right"></i>Defense Technology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/training-and-simulation">
                                                    <i class="fa fa-angle-right"></i>Training and Simulation
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/aircraft-parts-and-components">
                                                    <i class="fa fa-angle-right"></i>Aircraft Parts and Components
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/aerospace-defense/business-jet">
                                                    <i class="fa fa-angle-right"></i>Business Jet
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/agriculture.png" data-src="../../../img/home_image/agriculture.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/agriculture">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Agriculture</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/agriculture/agriculture-commodity">
                                                    <i class="fa fa-angle-right"></i>Agriculture Commodity
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/agriculture/agriculture-machinery">
                                                    <i class="fa fa-angle-right"></i>Agriculture Machinery
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/agriculture/seeds">
                                                    <i class="fa fa-angle-right"></i>Seeds
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/agriculture/agrochemicals">
                                                    <i class="fa fa-angle-right"></i>Agrochemicals
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/agriculture/regional-animal-feed">
                                                    <i class="fa fa-angle-right"></i>Regional Animal Feed
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/agriculture/animal-feed">
                                                    <i class="fa fa-angle-right"></i>Animal Feed
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/agriculture.png" data-src="../../../img/home_image/agriculture.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/animal-nutrition">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Animal Nutrition &amp; Wellness</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/animal-health">
                                                    <i class="fa fa-angle-right"></i>Animal Health
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/Pet-Care">
                                                    <i class="fa fa-angle-right"></i>Pet Care
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/feed-software-and-technologies">
                                                    <i class="fa fa-angle-right"></i>Feed Software and Technologies
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/feed-additives-market">
                                                    <i class="fa fa-angle-right"></i>Feed Additives Market
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/feed-premix">
                                                    <i class="fa fa-angle-right"></i>Feed Premix
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/compound-feed">
                                                    <i class="fa fa-angle-right"></i>Compound Feed
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/animal-nutrition/pet-food">
                                                    <i class="fa fa-angle-right"></i>Pet Food
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/automation.png" data-src="../../../img/home_image/automation.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/automation">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Automation</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/automation/Logistics">
                                                    <i class="fa fa-angle-right"></i>Logistics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automation/industrial-automation-and-process-control">
                                                    <i class="fa fa-angle-right"></i>Industrial Automation &amp; Process Control
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automation/Engineering-Products-and-Components">
                                                    <i class="fa fa-angle-right"></i>Engineering Products &amp; Components
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automation/robotics">
                                                    <i class="fa fa-angle-right"></i>Robotics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automation/building-automation">
                                                    <i class="fa fa-angle-right"></i>Building Automation
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automation/industrial-automation">
                                                    <i class="fa fa-angle-right"></i>Industrial Automation
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row category_row crow1">
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/automotive.png" data-src="../../../img/home_image/automotive.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/automotive">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Automotive</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/automotive/Manufacturing-Processes ">
                                                    <i class="fa fa-angle-right"></i>Manufacturing Processes
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/Automotive-Services">
                                                    <i class="fa fa-angle-right"></i>Automotive Services
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/machinery-and-equipment">
                                                    <i class="fa fa-angle-right"></i>Machinery and Equipment
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/parts-and-components">
                                                    <i class="fa fa-angle-right"></i>Parts and Components
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/automotive-die-casting">
                                                    <i class="fa fa-angle-right"></i>Automotive Die Casting
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/automotive-materials-coatings">
                                                    <i class="fa fa-angle-right"></i>Automotive Materials &amp; Coatings
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/sensors-softwares">
                                                    <i class="fa fa-angle-right"></i>Sensors/Softwares
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/vehicles">
                                                    <i class="fa fa-angle-right"></i>Vehicles
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/automotive-technology">
                                                    <i class="fa fa-angle-right"></i>Automotive Technology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/automotive/automotive-security">
                                                    <i class="fa fa-angle-right"></i>Automotive Security
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/chemicals-.png" data-src="../../../img/home_image/chemicals-.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/chemicals-materials">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Chemicals &amp; Materials</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/advanced-materials">
                                                    <i class="fa fa-angle-right"></i>Advanced Materials
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/specialty-and-fine-chemicals">
                                                    <i class="fa fa-angle-right"></i>Specialty &amp; Fine Chemicals
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/paints-and-coatings">
                                                    <i class="fa fa-angle-right"></i>Paints &amp; Coatings
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/commodity-chemicals">
                                                    <i class="fa fa-angle-right"></i>Aromatics and Intermediates
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/plastics-polymers-and-elastomers">
                                                    <i class="fa fa-angle-right"></i>Plastics, Polymers, and Elastomers
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/water-wastewater-treatment">
                                                    <i class="fa fa-angle-right"></i>Water &amp; Wastewater Treatment
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/construction-chemicals-materials">
                                                    <i class="fa fa-angle-right"></i>Construction Chemicals &amp; Materials
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/metals-ceramics-industrial-materials">
                                                    <i class="fa fa-angle-right"></i>Metals, Ceramics, &amp; Industrial Materials
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/chemicals-materials/adhesives-sealants">
                                                    <i class="fa fa-angle-right"></i>Adhesives &amp; Sealants
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/consumer-goods.png" data-src="../../../img/home_image/consumer-goods.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/consumer-goods-and-services">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Consumer Goods and Services</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/consumer-goods-and-services/appliances">
                                                    <i class="fa fa-angle-right"></i>Appliances
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/consumer-goods-and-services/personal-care">
                                                    <i class="fa fa-angle-right"></i>Personal Care
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/semiconductors.png" data-src="../../../img/home_image/semiconductors.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/Electronics">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Electronics</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Semiconductors">
                                                    <i class="fa fa-angle-right"></i>Semiconductors
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Security-and-Surveillance">
                                                    <i class="fa fa-angle-right"></i>Security &amp; Surveillance
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Optoelectronics">
                                                    <i class="fa fa-angle-right"></i>Optoelectronics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Monitoring-and-Testing-Equipment">
                                                    <i class="fa fa-angle-right"></i>Monitoring and Testing Equipment
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Electrical-and-Electronic-Components">
                                                    <i class="fa fa-angle-right"></i>Electrical &amp; Electronic Components
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/Display-Technology">
                                                    <i class="fa fa-angle-right"></i>Display Technology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/semiconductors-security">
                                                    <i class="fa fa-angle-right"></i>Electronic Security
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/electronics-systems-and-devices">
                                                    <i class="fa fa-angle-right"></i>Electronics Systems and Devices
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/Electronics/sensors">
                                                    <i class="fa fa-angle-right"></i>Sensors
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/energy-&-power.png" data-src="../../../img/home_image/energy-&-power.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/energy-power">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Energy &amp; Power</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/energy-power/power-storage">
                                                    <i class="fa fa-angle-right"></i>Power Storage
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/eenewables">
                                                    <i class="fa fa-angle-right"></i>Renewables
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/regional-outlook">
                                                    <i class="fa fa-angle-right"></i>Regional Outlook
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/power-epc">
                                                    <i class="fa fa-angle-right"></i>Power EPC
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/upstream">
                                                    <i class="fa fa-angle-right"></i>Upstream
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/oil-and-gas-epc">
                                                    <i class="fa fa-angle-right"></i>Oil and Gas EPC
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/miscellaneous">
                                                    <i class="fa fa-angle-right"></i>Miscellaneous
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/midstream">
                                                    <i class="fa fa-angle-right"></i>Midstream
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/energy-efficiency-solutions">
                                                    <i class="fa fa-angle-right"></i>Energy Efficiency Solutions
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/Downstream">
                                                    <i class="fa fa-angle-right"></i>Downstream
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/asset-integrity">
                                                    <i class="fa fa-angle-right"></i>Asset Integrity
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/power-distribution">
                                                    <i class="fa fa-angle-right"></i>Power Distribution

                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/power-transmission">
                                                    <i class="fa fa-angle-right"></i>Power Transmission

                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/energy-power/power-generation">
                                                    <i class="fa fa-angle-right"></i>Power Generation

                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row category_row crow1">
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/automotive.png"  alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/financial-services-and-investment-intelligence">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Financial Services and Investment Intelligence</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/financial-services-and-investment-intelligence/insurance">
                                                    <i class="fa fa-angle-right"></i>Insurance
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/food-&-beverage.png" data-src="../../../img/home_image/food-&-beverage.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/food-beverage">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Food &amp; Beverage</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/Food">
                                                    <i class="fa fa-angle-right"></i>Food
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/beverage">
                                                    <i class="fa fa-angle-right"></i>Beverages
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/processed-food">
                                                    <i class="fa fa-angle-right"></i>Processed Food
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/supplements">
                                                    <i class="fa fa-angle-right"></i>Supplements
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/additives">
                                                    <i class="fa fa-angle-right"></i>Additives
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/food-beverage/ingredients">
                                                    <i class="fa fa-angle-right"></i>Ingredients
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/healthcare.png" data-src="../../../img/home_image/healthcare.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/healthcare">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Healthcare</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/healthcare/therapeutics">
                                                    <i class="fa fa-angle-right"></i>Therapeutics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/pharmaceuticals">
                                                    <i class="fa fa-angle-right"></i>Pharmaceuticals
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/biotechnology">
                                                    <i class="fa fa-angle-right"></i>Biotechnology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/healthcare-it">
                                                    <i class="fa fa-angle-right"></i>Healthcare IT
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/diagnostics">
                                                    <i class="fa fa-angle-right"></i>Diagnostics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/medical-devices">
                                                    <i class="fa fa-angle-right"></i>Medical Devices
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/healthcare/molecular-diagnostics-healthcare">
                                                    <i class="fa fa-angle-right"></i>Molecular Diagnostics
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/Information.png" data-src="../../../img/home_image/Information.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/information-communications-technology">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Information &amp; Communications Technology</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Telecom">
                                                    <i class="fa fa-angle-right"></i>Telecom
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Software-and-Solutions">
                                                    <i class="fa fa-angle-right"></i>Software &amp; Solutions
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/IT-Hardware">
                                                    <i class="fa fa-angle-right"></i>IT Hardware
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/IoT-BigData-M2M">
                                                    <i class="fa fa-angle-right"></i>IoT/BigData/M2M
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Internet">
                                                    <i class="fa fa-angle-right"></i>Internet
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Data-Center">
                                                    <i class="fa fa-angle-right"></i>Data Center
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Cloud-Computing">
                                                    <i class="fa fa-angle-right"></i>Cloud Computing
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/Analytics">
                                                    <i class="fa fa-angle-right"></i>Analytics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/information-technology">
                                                    <i class="fa fa-angle-right"></i>Information Technology
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/communication">
                                                    <i class="fa fa-angle-right"></i>Communication
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/internet-of-things">
                                                    <i class="fa fa-angle-right"></i>Internet of Things
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/security">
                                                    <i class="fa fa-angle-right"></i>Security
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/information-communications-technology/infrastructure">
                                                    <i class="fa fa-angle-right"></i>Infrastructure
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/automotive.png" data-src="../../../img/home_image//investment.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/investment-opportunities">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Investment Opportunities</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/market-entry">
                                                    <i class="fa fa-angle-right"></i>Market Entry
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/europe">
                                                    <i class="fa fa-angle-right"></i>Europe
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/asia-pacific">
                                                    <i class="fa fa-angle-right"></i>Asia-Pacific
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/south-america">
                                                    <i class="fa fa-angle-right"></i>South America
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/africa">
                                                    <i class="fa fa-angle-right"></i>Africa
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/investment-opportunities/gulf-cooperation-council-gcc">
                                                    <i class="fa fa-angle-right"></i>Gulf Cooperation Council (GCC)
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row category_row crow1">
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/Manufacturing.png" data-src="../../../img/home_image/Manufacturing.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/manufacturing-processes">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Manufacturing Processes </h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/manufacturing-processes/supply-chain-services">
                                                    <i class="fa fa-angle-right"></i>Supply Chain &amp; Services
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/manufacturing-processes/machinery-equipment">
                                                    <i class="fa fa-angle-right"></i>Machinery &amp; Equipment
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/manufacturing-processes/machine-tools">
                                                    <i class="fa fa-angle-right"></i>Machine Tools
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/manufacturing-processes/industry-specific-reports">
                                                    <i class="fa fa-angle-right"></i>Industry Specific Reports
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/packaging.png" data-src="../../../img/home_image/packaging.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/packaging">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Packaging</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/packaging/Pharmaceutical-Packaging">
                                                    <i class="fa fa-angle-right"></i>Pharmaceutical Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Personal-Care-Packaging">
                                                    <i class="fa fa-angle-right"></i>Personal Care Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Packaging-Materials-and-Types">
                                                    <i class="fa fa-angle-right"></i>Packaging Materials and Types
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Packaging-Equipment">
                                                    <i class="fa fa-angle-right"></i>Packaging Equipment
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Industrial-Packaging">
                                                    <i class="fa fa-angle-right"></i>Industrial Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Household-Packaging">
                                                    <i class="fa fa-angle-right"></i>Household Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Food-Packaging">
                                                    <i class="fa fa-angle-right"></i>Food Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Beverage-Packaging">
                                                    <i class="fa fa-angle-right"></i>Beverage Packaging
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/packaging/Advanced-Packaging">
                                                    <i class="fa fa-angle-right"></i>Advanced Packaging
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-15 col-xs-12 eq_row">
                                <div class="pad10">
                                    <div class="category-img">
                                        <img src="../../../img/home_image/automation.png" data-src="../../../img/home_image/automation.png" alt="mordor icon" />
                                    </div>
                                    <a href="/industry-reports/category/real-estate">
                                        <div class="category-titl">
                                            <h3 class="cate_title">Real Estate</h3>
                                        </div>
                                    </a>
                                    <div>
                                        <ul class="subcate_title">
                                            <li>
                                                <a href="/industry-reports/category/real-estate/hospitality-real-estate">
                                                    <i class="fa fa-angle-right"></i>Hospitality Real Estate
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/real-estate/infrastructure-sector">
                                                    <i class="fa fa-angle-right"></i>Infrastructure Sector
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/real-estate/residential-real-estate">
                                                    <i class="fa fa-angle-right"></i>Residential Real Estate
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/industry-reports/category/real-estate/commercial-real-estate">
                                                    <i class="fa fa-angle-right"></i>Commercial Real Estate
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default CategoryHome;


// WEBPACK FOOTER //
// ./src/home/category-home/category-home.js